// A phone photo made smaller before it's uploaded: at most `maxSide` pixels
// on its long side, as a JPEG, so a 4 MB photo goes up as a few hundred KB.
// The original comes back when it's already small or can't be read here
// (an iPhone HEIC photo in a desktop browser, say).
export async function shrinkImage(file, { maxSide = 1600, quality = 0.82 } = {}) {
  if (!file || !/^image\//.test(file.type) || /gif$/i.test(file.type)) return file
  try {
    const bitmap = await (typeof createImageBitmap === 'function'
      ? createImageBitmap(file, { imageOrientation: 'from-image' })
      : new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = URL.createObjectURL(file)
      }))
    const { width, height } = bitmap
    const scale = Math.min(1, maxSide / Math.max(width, height))
    if (scale === 1 && file.size < 700 * 1024) return file
    const canvas = document.createElement('canvas')
    canvas.width = Math.round(width * scale)
    canvas.height = Math.round(height * scale)
    canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height)
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality))
    if (!blob || blob.size >= file.size) return file
    const name = `${String(file.name || 'photo').replace(/\.[^.]+$/, '')}.jpg`
    return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() })
  } catch {
    return file
  }
}
